<template>
    <div class="classDetial">
        <!-- 返回 -->
        <div class="toReturn" @click="toReturn">
            <img src="../../assets/img/nav_return.svg" />
            <h4>返回</h4>
        </div>
        <!-- 课程信息 -->
        <div class="top_cont" v-for="(item,index) in courseDetial" :key="index">
            <img :src="item.ImgPath" />
            <div class="infoWrap">
                <h3>{{item.Title}}</h3>
				<div class="classBox mobileClassBox">
				    <div class="study">
				        <div class="beginStudy" @click="beginStudy"><img src="../../assets/img/study.svg" /><span>{{study}}</span></div>
				        <p class="UseTime">已学习至<span>{{studyPro}}</span>%</p>
				    </div>
				    <div class="kpBtn" @click="evaluateFn"><img src="../../assets/img/evaluated.svg" v-if="pjLight" /><img src="../../assets/img/pj_icon.svg" v-else /><span>{{evaluate}}</span></div>
				</div>
                <p class="synopsis">简介:{{item.Sketch}}</p>
                <div class="bsxWrap">
                    <p><span>{{item.Hits}}</span><span>播放</span></p>
                    <p><span>{{item.Duration}}</span><span>时长</span></p>
                    <p><span>{{item.Score}}</span><span>学分</span></p>
                </div>
                <p class="category"><span>{{item.Keywords}}</span></p>
                <div class="head-date">
                    <div class="hd-dsWrap">
                        <div class="hdBox">
                            <div class="head"><img src="../../assets/img/speaker.jpg" /><span>{{item.LectureName}}</span></div>
							<p class="department" v-if="item.Memo != '无' && item.Memo != ''"><img src="../../assets/img/class_icon.svg" ><span>{{item.Memo}}</span></p>
                        </div>
                        <div class="dsWrap">
							<div class="dateWrap">
								<div class="zan" @click="dianzan">
									<p><img src="../../assets/img/zanAfter.svg" v-if="zanLight"/><img src="../../assets/img/zan.svg"  v-else/></p>
									<span>{{'点赞('+dianzanNum+')'}}</span>
								</div>
								<p>日期：<span>{{item.PubDate | formatDate}}</span></p>
							</div>
                            <!-- 点赞用户 -->
                            <div class="dzPerson">
                                <span v-for="(item,index) in hitUserList" :key="index">{{item.Name | formatName}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="classBox pcClassBox">
                        <div class="study">
                            <div class="beginStudy" @click="beginStudy"><img src="../../assets/img/study.svg" /><span>{{study}}</span></div>
                            <p class="UseTime">已学习至<span>{{studyPro}}</span>%</p>
                        </div>
                        <div class="kpBtn" @click="evaluateFn"><img src="../../assets/img/evaluated.svg" v-if="pjLight" /><img src="../../assets/img/pj_icon.svg" v-else /><span>{{evaluate}}</span></div>
                    </div>
                </div>
                <!-- 点赞用户 -->
                <div class="dzPerson">
                    <span v-for="(item,index) in hitUserList" :key="index">{{item.Name | formatName}}</span>
                </div>
            </div>
        </div>
        <!-- 课程介绍 -->
        <div class="kzkWrap">
            <router-link to="/classDetial/courseCatalogue">课程目录<span class="line"></span></router-link>
            <router-link :to='"/classDetial/speaker/"+LectureID'>主讲人介绍<span class="line"></span></router-link>
            <router-link :to='{name:"CourseIntroduction",params:{abstract:abstract}}'>课程介绍<span class="line"></span></router-link>
        </div>
        <!-- 相关内容 -->
        <div class="menuContWrap">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import '../../assets/js/formatTime'
export default {
    data() {
        return {
            study:'开始学习',
            evaluate:'课程评价',
            zanLight:false,  // 是否已点赞
            pjLight:false,  // 是否已评价
            courseDetial:[],  // 课程详情
            courseId:undefined,  // 课程id
            active:0,
            LectureID:0,  // 主讲人id
            dianzanNum:0,  // 点赞数
            hitUserList:[],  // 点赞人列表
            studyPro:0,  // 学习进度
            classID:0,  // 课件ID
            lessonList:[],  // 每个视频的状态
            isFinished:false,  // 完成状态
            CurLessonID:undefined,  // 最近一次播放的学习ID
			abstract:''  // 课程介绍
        }
    },
    mounted(){
        // 获取课程id
        this.courseId = this.$route.query.courseId;
        if(this.courseId == undefined){
           this.courseId = sessionStorage.getItem('courseID');
        }
        
        // 获取课程详情
        this.getClassDetial();

        // 获取用户点赞接口
        this.getUser();
    },
    methods: {
        // 获取课程详情
        getClassDetial(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId
            }
            this.$axios.post(Const_Api_Root+'api/Course/Info',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.LectureID = res.data.Data.LectureID;
					this.abstract = res.data.Data.Abstract;
                    // 点赞状态
                    if(res.data.Data.IsTag){
                        this.zanLight = true;
                    }
                    // 是否已评价
                    if(res.data.Data.IsComment){
                        this.pjLight = true;
                        this.evaluate = '已评价';
                    }
                    // 格式化关键词
                    let keyWord = res.data.Data.Keywords;
                    if(keyWord != undefined){
                        res.data.Data.Keywords = keyWord.toString();
                    }
                    // 获取课程详情
                    this.courseDetial.push(res.data.Data);
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).then((res)=>{ 
                this.getStudyStut();
                document.title = this.courseDetial[0].Title + '_云课堂';
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取用户点赞
        getUser(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "Num":20
            }
            this.$axios.post(Const_Api_Root+'api/Course/GetTagUsers',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.hitUserList = res.data.Data.Rows;
                    this.dianzanNum = res.data.Data.Total;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 点赞
        dianzan(){
            if(this.zanLight){
                this.$message({
                    message: "您已点赞，无需重复操作！",
                    type: 'warning',
                    duration: 3000
                });
                return;
            };

            this.zanLight = true;
            this.dianzanNum = this.dianzanNum + 1;
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId
            }
            this.$axios.post(Const_Api_Root+'api/Course/PutTags',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.getUser();
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                    this.zanLight = false;
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 课件学习状态
        getStudyStut(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "Flag":1
            }
            this.$axios.post(Const_Api_Root+'api/Course/MyClass',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 获取学习进度
                    this.studyPro = res.data.Data.Process;
                    this.classID = res.data.Data.ClassID;
                    this.lessonList = res.data.Data.Lessons;
                    this.isFinished = res.data.Data.IsFinished;
                    this.CurLessonID = res.data.Data.CurLessonID;
                    // 判断用户是否学习过
                    if(this.classID == 0){
                        this.study = '开始学习';
                    }else{
                        this.study = '继续学习';
                    }
                    // 用户如果未评价  且学习进度大于0%，显示弹窗
                    if(this.pjLight) return;

                    if(this.studyPro > 0){
                        this.$alert('填写完课程评价后才能获得学分', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 开始学习
        beginStudy(){
            // 未学习过
            if(this.classID == 0){
                this.creatNewCourseware();
            }
            // 正在学习中
            if(this.classID > 0 && !this.isFinished){
                if(this.CurLessonID == 0){
                    this.$router.push({
                        path: '/playVideo',
                        query: {
                            courseId:this.courseId
                        }
                    });
                }else{
                    for(let i=0;i<this.lessonList.length;i++){
                        if(this.CurLessonID == this.lessonList[i].LessonID){
                            this.$router.push({
                                path: '/playVideo',
                                query: {
                                    courseId:this.courseId,
                                    id:this.lessonList[i].VideoID
                                }
                            });
                            return;
                        }
                    }
                }
            }
            // 已完成学习
            if(this.classID > 0 && this.isFinished){
                this.$router.push({
                    path: '/playVideo',
                    query: {
                        courseId:this.courseId
                    }
                });
            }
        },
        // 创建新课件
        creatNewCourseware(){
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "SecSplit":30
            }
            this.$axios.post(Const_Api_Root+'api/Course/CreateClass',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 跳转
                    this.$router.push({
                        path: '/playVideo',
                        query: {
                            courseId:this.courseId
                        }
                    });
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 课程评价
        evaluateFn(){
            this.$router.push({
                path: '/curriculumEvaluation',
                query: {
                    courseId:this.courseId
                }
            });
        },
        // 添加样式
        clickActFn(ind){
            this.active = ind;
        },
        // 返回
        toReturn(){
            let returnPage = sessionStorage.getItem('returnPage');
            switch(returnPage){
                case 'MyCourse':
                    this.$router.push({
                        path: '/personalCenter/myCourse'
                    });
                    sessionStorage.removeItem('returnPage');
                    break;
                case 'LearnCount':
                    this.$router.push({
                        path: '/personalCenter/learnCount'
                    });
                    sessionStorage.removeItem('returnPage');
                    break;
                case 'search':
                    this.$router.push({
                        path: '/search',
                        query: {
                            type:'return'
                        }
                    });
                    sessionStorage.removeItem('returnPage');
                    break;
                default:
                    // this.$router.push({
                    //     path: '/index',
                    //     query: {
                    //         type:'return'
                    //     }
                    // });
					window.history.go(-1);
            }
        }
    },
    filters: {
        // 格式化时间
        formatDate:(value) => {
            value = new Date(value).Format("yyyy-MM-dd")
            return value;
        },
        // 格式化名字
        formatName:(val)=>{
            if(val.length == 4){
                val = val.substring(2);
            }else if(val.length == 2){
                val = val.substring(0);
            }else{
                val = val.substring(1);
            }
            return val;
        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .classDetial{
        width: 100%;
        margin: 20px 0;
        padding: 0 17px;
        box-sizing: border-box;
        .top_cont>img{
            width: 100%;
            height: auto;
            max-height: 284px;
            border-radius: 16px;
        }
        .infoWrap{
            h3{
                margin: 20px 0;
            }
			.mobileClassBox{
				margin-bottom: 40px;
			}
        }
        .head-date{
            display: flex;
            flex-direction: column;
			.pcClassBox{
				display: none;
			}
        }
        .UseTime{
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
        }
        .dsWrap{
            display: flex;
            flex-direction: column;
        }
    }
    .kzkWrap{
        margin: 60px 0 40px;
        a{
            margin-right: 30px;
        }
    }
    .infoWrap>.dzPerson{
        display: none;
    }
    .dzPerson{
        font-size: 0;
        display: flex;
		flex-wrap: wrap;
        span{
            display: inline-block;
            margin: 10px 20px 0 0;
            width: 47px;
            height: 47px;
            border-radius: 50%;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            line-height: 47px;
            background: #0061FE;
        }
    }
    .menuContWrap{
        min-height: 300px;
    }
}
@media screen and (min-width: 1445px) {
    .classDetial{
        width: 1200px;
        margin: 100px auto 0;
        .menuContWrap{
            min-height: 400px;
        }
        .top_cont{
            display: flex;
        }
        .top_cont>img{
            height: 314px;
            width: 420px;
            border-radius: 16px;
            margin-right: 40px;
        }
        .infoWrap{
            flex: 1;
			.mobileClassBox{
				display: none;
			}
        }
        .head-date{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }
        .UseTime{
            position: absolute;
            bottom: -40px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .dsWrap>.dzPerson{
        display: none;
    }
    .kzkWrap{
        margin: 70px 0;
        a{
            margin-right: 70px;
        }
    }
    .dzPerson{
        font-size: 0;
        margin: 25px 0 78px;
        display: flex;
		flex-wrap: wrap;
        span{
            display: inline-block;
            margin: 10px 20px 0 0;
            width: 47px;
            height: 47px;
            border-radius: 50%;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            line-height: 47px;
            background: #0061FE;
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .classDetial{
        width: 1100px;
        margin: 50px auto 0;
        .menuContWrap{
            min-height: 300px;
        }
        .top_cont{
            display: flex;
        }
        .top_cont>img{
            height: 314px;
            width: 420px;
            border-radius: 16px;
            margin-right: 40px;
        }
        .infoWrap{
            flex: 1;
			.mobileClassBox{
				display: none;
			}
        }
        .head-date{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }
        .UseTime{
            position: absolute;
            bottom: -40px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .dsWrap>.dzPerson{
        display: none;
    }
    .kzkWrap{
        margin: 50px 0;
        a{
            margin-right: 70px;
        }
    }
    .dzPerson{
        font-size: 0;
        margin: 5px 0 0;
        display: flex;
		flex-wrap: wrap;
        span{
            display: inline-block;
            margin: 10px 20px 0 0;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            background: #0061FE;
        }
    }
}
// 公用
.toReturn{
    width: 60px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    h4{
        font-size: 14px;
        font-weight: bold;
    }
    img{
        width: 30px;
        height: 30px;
    }
}
.infoWrap{
    h3{
        font-size: 24px;
    }
    .synopsis{
        font-size: 14px;
        color: rgba(25,25,26,0.80);
        letter-spacing: 0.5px;
        line-height: 28px;
        margin: 20px 0;
    }
    .bsxWrap{
        display: flex;
        p{
            margin-right: 40px;
            span{
                display: block;
                font-size: 14px;
                text-align: center;
                font-weight: bold;
            }
            span:last-child{
                color: rgba(25,25,26,0.80);
                font-size: 12px;
                margin-top: 7px;
                font-weight: normal;
            }
        }
    }
}
.category{
    font-size: 12px;
    color: #0061FE;
    margin: 20px 0 10px;
    span{
        margin-right: 10px;
    }
}
// 头像-开始学习-评价
.head-date{
    .head{
        font-size: 14px;
        color: rgba(25,25,26,0.80);
        img{
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
    .hdBox{
        display: flex;
        align-items: center;
        margin: 20px 0;
        p{
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            line-height: 14px;
            margin-left: 28px;
        }
    }
	.department{
		margin-left: 30px !important;
		img{
			vertical-align: middle;
			margin-right: 10px;
			width: 24px;
			height: 24px;
		}
	}
}
.classBox{
	display: flex;
	align-items: center;
	margin-top: 20px;
	.kpBtn,.beginStudy{
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 22px;
		height: 44px;
		width: 160px;
		cursor: pointer;
	}
	.study{
		position: relative;
		.beginStudy{
			background: #0061FE;
			box-shadow: 0 24px 24px 0 rgba(0,97,254,0.20);
			border-radius: 22px;
			font-size: 16px;
			color: #FFFFFF;
			&:hover{
				background: #4089FF;
			}
			img{
				width: 20px;
				height: 20px;
				margin-right: 11px;
			}
		}
		.UseTime{
			width: 160px;
			text-align: center;
			font-size: 16px;
			color: #0061FE;
		}
	}
	.kpBtn{
		margin-left: 40px;
		font-size: 16px;
		font-weight: bold;
		border: 1px solid rgba(25,25,26,0.20);
		img{
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}
		&:hover{
			background: rgba(25,25,26,0.20);
		}
	}
	
}
.zan{
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
	margin-right: 30px;
}
.dsWrap{
    img{
        width: 30px;
        height: 30px;
        margin-right: 6px;
    }
    p{
		line-height: 30px;
        font-size: 12px;
        color: #19191A;
        height: 30px;
    }
}
.dateWrap{
	display: flex;
}
// 导航
.kzkWrap{
    display: flex;
    align-items: center;
    a{
        display: block;
        height: 36px;
        font-size: 15px;
        color: #19191A;
		
		position: relative;
    }
	.line{
		display: none;
		width: 50px;
		height: 4px;
		border-radius: 2px;
		background-color: #0061FE;
		
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}
}
.router-link-active{
    color: #0061FE;
    .line{
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/class/ClassDetial.vue